import { Dialog, TextField } from "@mui/material";
import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";
import { useState } from "react";
import { defValueNaturezaRendimento, IDataNaturezaRendimento } from "../../types/api/financeiro/pesquisar-natureza-rendimentos";

export default function SelectNaturezaRendimento({
    value,
    onChange,
    required = false,
    error = false,
    isDisabled = false,
    extraParams = {}
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false)

    const handleClose = () => setOpenModal(false)

    const inputLabel = value ? `${value.codigo} - ${value.nome}` : ""

    return (
        <>
            <TextField
                {...{ required, error }}
                label={`Natureza rendimento`}
                variant="outlined"
                fullWidth
                disabled={isDisabled}
                onClick={() => {
                    if (isDisabled) return
                    setOpenModal(true)
                }}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        setOpenModal(true);
                    }
                }}
                slotProps={{
                    input: { readOnly: true }
                }}
                value={inputLabel}
                helperText={error ? "Campo obrigatório" : ""}
            />

            {
                openModal &&
                <Dialog
                    fullWidth
                    maxWidth="md"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        {...{ handleClose, extraParams }}
                        title="Selecione uma natureza rendimento"
                        queryPath="/financeiro/pesquisar-natureza-rendimentos"
                        getItemKey={(item) => item.codigo}
                        getItemLabel={(item) => `${item.codigo} - ${item.nome}`}
                        defaultValue={value || defValueNaturezaRendimento}
                        onChange={(value) => {
                            onChange(value as TObjValue)
                            handleClose()
                        }}
                    />
                </Dialog>

            }
        </>
    )
}

interface SelectSimpleApiQueryProps {
    value: IDataNaturezaRendimento | null,
    onChange: (arg: TObjValue | null) => void
    error?: boolean
    required?: boolean;
    isDisabled?: boolean;
    extraParams?: { [key: string]: any };
}

export type TObjValue = IDataNaturezaRendimento